import {
  required,
  unique,
  shape,
  items,
  concatFailure,
  fromParent,
  when,
  Validator,
  Success,
  Failure,
  ValidationError
} from '@totalsoft/pure-validations';
import i18next from 'i18next';

export const allowedStateValidator = shape({
  documentStateId: required
});
export const allowedStateReasonValidator = concatFailure(
  unique(x => x.reasonId || {}, 'DocumentTypes.DocumentAllowedState.Validators.ReasonUnique'),
  items(
    shape({
      reasonId: required
    })
  )
);

export const statesAreDifferent = Validator(function statesAreDifferent(model) {
  return model.fromStateId === model.toStateId && model.changed
    ? Failure(ValidationError(i18next.t('DocumentTypes.DocumentStateTransition.StateTransitionsMustBeDifferent')))
    : Success;
});
export const stateTransitionValidator =
  [
    shape({
      fromStateId: fromParent(parent => required |> when(!parent.isInitial)),
      toStateId: fromParent(parent => required |> when(!parent.isFinal))
    }),
    statesAreDifferent
  ] |> concatFailure;

export const documentTypeXPropertyValidator = shape({
  documentTypeId: required,
  propertyId: required
});

export const documentTypeXPropertyStatesValidator = concatFailure(
  unique(x => x.documentStateId || {}, 'DocumentTypes.DocumentTypeProperty.EditDocumentTypeProperty.StateUnique'),
  items(
    shape({
      documentStateId: required
    })
  )
);
